module.exports = __webpack_public_path__ + "img/user.f0c6d27a.png";